import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useApplicationFieldVisibility } from "@Client/@Composables/application-standalone/useApplicationFieldVisibility";
import { computed } from "@vue/composition-api";
import { useFillOutVisibility } from "@Client/@Composables/application-standalone/useFillOutVisibility";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
export const useIncomeHistoryFieldVisibility = options => {
  const {
    computeSchemaVisibility,
    computeTogglerVisibility
  } = useApplicationFieldVisibility();
  const {
    computeFillOutVisibility
  } = useFillOutVisibility();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentIncomePath = computed(() => {
    return currentApplicantPath.value + "[employment]" + `[${options.employmentIndex.value}]`;
  });
  const currentIncomeVisibilityPath = computed(() => {
    var _context;
    return _replaceAllInstanceProperty(_context = currentIncomePath.value).call(_context, /\[[[0-9]+\]/g, "");
  });
  const isApplicantVisibleFromFillOut = computed(() => {
    var _options$applicantId;
    return computeFillOutVisibility(APPLICATION_STEPS.INCOME_HISTORY, {
      applicantId: (_options$applicantId = options.applicantId) == null ? void 0 : _options$applicantId.value
    }).value;
  });
  const incomeEmployerNameVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[employer-name]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeCurrentJobVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[current-job]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeCompanyTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[company-type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeEmploymentTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[employment-type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeGrossRevenueVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[gross-revenue]");
    const visibleFromToggler = computeTogglerVisibility(currentIncomePath.value + "[gross-revenue]", [currentIncomePath.value + "[self-employed]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const incomeIncomeAmountVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[income-amount]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeIncomePeriodVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[income-period]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeIncomeTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[income-type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeIndustrySectorVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[industry-sector]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeJobTitleVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[job-title]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeMonthsInIndustryVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[months-in-industry]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeOccupationVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[occupation]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeOperatingAsVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[operating-as]");
    const visibleFromToggler = computeTogglerVisibility(currentIncomePath.value + "[operating-as]", [currentIncomePath.value + "[self-employed]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const incomeSelfEmployedVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[self-employed]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeTimeAtJobVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[time-at-job]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeWorkPhoneVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[work-phone]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const incomeAddressVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[address]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const isIncomeHistorySectionVisibleForApplicant = computed(() => incomeEmployerNameVisible.value || incomeCurrentJobVisible.value || incomeCompanyTypeVisible.value || incomeEmploymentTypeVisible.value || incomeGrossRevenueVisible.value || incomeIncomeAmountVisible.value || incomeIncomePeriodVisible.value || incomeIncomeTypeVisible.value || incomeIndustrySectorVisible.value || incomeJobTitleVisible.value || incomeMonthsInIndustryVisible.value || incomeOccupationVisible.value || incomeOperatingAsVisible.value || incomeSelfEmployedVisible.value || incomeTimeAtJobVisible.value || incomeWorkPhoneVisible.value || incomeAddressVisible.value);
  return {
    incomeEmployerNameVisible,
    incomeCurrentJobVisible,
    incomeCompanyTypeVisible,
    incomeEmploymentTypeVisible,
    incomeGrossRevenueVisible,
    incomeIncomeAmountVisible,
    incomeIncomePeriodVisible,
    incomeIncomeTypeVisible,
    incomeIndustrySectorVisible,
    incomeJobTitleVisible,
    incomeMonthsInIndustryVisible,
    incomeOccupationVisible,
    incomeOperatingAsVisible,
    incomeSelfEmployedVisible,
    incomeTimeAtJobVisible,
    incomeWorkPhoneVisible,
    incomeAddressVisible,
    isIncomeHistorySectionVisibleForApplicant
  };
};